import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import dataContext from '../../../context/dataContext'
import userRequests from '../../../components/api/userRequests'
import Loader from '../../../components/Common/Loader/Loader'
function SignGoogleUser() {
    const navigate = useNavigate()
    const { token, refresh } = useParams()
    const { userDetails, setUserDetails, serverData } = useContext(dataContext);

    useEffect(() => {
        localStorage.setItem("access_token", token);
        localStorage.setItem("refresh_token", refresh);
        // setTimeout(() => {
        //     navigate("/", { replace: false })
        // }, 1000)
        // userRequests.getUserDetails().then(data => {
        //     console.log("🚀 ~ file: SignGoogleUser.jsx:16 ~ userRequests.getUserDetails ~ data.data:", data.data)
        //     // setUserDetails(data.data)
        window.location.href = process.env.REACT_APP_LOCAL_URL

        // })

    }, [])
    return (
        <Loader />
    )
}

export default SignGoogleUser